// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9326 ? "f70991a6" : chunkId) + "." + {"2741":"653c787f2490dc24","2911":"bb953fc9821daf7f","5840":"0c6b4e9e3df4cb08","9326":"7abe7e9209e01505","9651":"bddd959a7c85efc2"}[chunkId] + ".js";
};